import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-wrap',
        },
      },
    },
  },
});

export default theme.components;
